import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

/**
 * Routes llm-config. Détail fragments = `:key`, presets = `:id` (le gateway
 * mappe `:id` → `key`). `new` et détail partagent le même contexte (vue
 * bimode create/edit). Les routes template ont disparu avec l'écran
 * (ADR SAAS-A-184 D1, SAAS-995) — un preset compose directement ses fragments.
 */
export const adminLlmConfigRoutes: RouteObject[] = [
  {
    path: 'admin/llm-config/fragments',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_LLM_FRAGMENTS, title: 'Fragments' },
  },
  {
    path: 'admin/llm-config/fragments/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_LLM_FRAGMENT_FORM, title: 'Nouveau fragment' },
  },
  {
    path: 'admin/llm-config/fragments/:key',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_LLM_FRAGMENT_FORM, title: 'Fragment' },
  },
  {
    path: 'admin/llm-config/presets',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_LLM_PRESETS, title: 'Presets' },
  },
  {
    path: 'admin/llm-config/presets/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_LLM_PRESET_FORM, title: 'Nouveau preset' },
  },
  {
    path: 'admin/llm-config/presets/:id',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_LLM_PRESET_FORM, title: 'Preset' },
  },
];
